import { atom } from 'jotai';

export interface IManagerInfoAtom {
  email: string;
  phone: string;
  name: string;
}

export const mangerInfoAtom = atom<IManagerInfoAtom>();
